import type { VoidsSummaryReportItem } from "../../../../graphql/types"

export const CLEAR_VOIDS_REPORT_DATA = "voidsReport/clear"

export const clearVoidsReportData = () => ({
    type: CLEAR_VOIDS_REPORT_DATA,
})

export const VOIDS_REPORT_AGENDA_MOUNTED = "voidsReport/mounted"

export const voidsReportAgendaMounted = () => ({
    type: VOIDS_REPORT_AGENDA_MOUNTED,
})
// LOG

export const FETCH_VOIDS_LOG_REPORT_REQUESTED = "voidsReport/log/requested"

export const fetchVoidsLogReportRequested = () => ({
    type: FETCH_VOIDS_LOG_REPORT_REQUESTED,
})

export const FETCH_VOIDS_LOG_REPORT_SUCCESS = "voidsReport/log/success"

export const fetchVoidsLogReportSuccess = (data: any[]) => ({
    type: FETCH_VOIDS_LOG_REPORT_SUCCESS,
    payload: {
        data: data,
    },
})

export const FETCH_VOIDS_LOG_REPORT_FAILURE = "voidsReport/log/failure"

export const fetchVoidsLogReportFailure = (error?: any) => ({
    type: FETCH_VOIDS_LOG_REPORT_FAILURE,
    payload: {
        error: error,
    },
})
// SUMMARY

export const FETCH_VOIDS_SUMMARY_REPORT_REQUESTED = "voidsReport/summary/requested"

export const fetchVoidsSummaryReportRequested = () => ({
    type: FETCH_VOIDS_SUMMARY_REPORT_REQUESTED,
})

export const FETCH_VOIDS_SUMMARY_REPORT_SUCCESS = "voidsReport/summary/success"

export const fetchVoidsSummaryReportSuccess = (data: VoidsSummaryReportItem[]) => ({
    type: FETCH_VOIDS_SUMMARY_REPORT_SUCCESS,
    payload: {
        data: data,
    },
})

export const FETCH_VOIDS_SUMMARY_REPORT_FAILURE = "voidsReport/summary/failure"

export const fetchVoidsSummaryReportFailure = (error?: any) => ({
    type: FETCH_VOIDS_SUMMARY_REPORT_FAILURE,
    payload: {
        error: error,
    },
})
